module.exports = __webpack_public_path__ + "static/media/banner-promo.5d94bfa8.png";